var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"ArticleDetail text-left",attrs:{"data-title":"详情"}},[_c('ArticleDetailCom',{attrs:{"fetchDetailApi":_vm.getArticleDetail,"detailId":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }